import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const PagosAlertas = ({ filters, refreshTrigger }) => {
    const { token } = useToken();
    const { showErrorToast } = useToast();

    const [cargando, setCargando] = useState(true);
    const [alertasPagos, setAlertasPagos] = useState({});
    const [showAlertas] = useState(true);

    useEffect(() => {
        if (filters.month && filters.year) {
            ObtenerAlertas();
        }
    }, [
        filters.month,
        filters.year,
        filters.idCatCuentaBancaria,
        filters.idCatMedioPago,
        filters.idVendedor,
        filters.filterValidados,
        filters.filterStatus,
        refreshTrigger
    ]);

    const ObtenerAlertas = async () => {
        setCargando(true);
        // Endpoint nuevo exclusivo para Alertas
        const url = `/api/AdministracionPagos/ObtenerPagosAlertas/?month=${filters.month}&year=${filters.year}&idCatCuentaBancaria=${filters.idCatCuentaBancaria}&idMedioPago=${filters.idCatMedioPago}&idVendedor=${filters.idVendedor}&iValidado=${filters.filterValidados}&iEstatus=${filters.filterStatus}`;

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('' + error.message);
        });

        if (response && response.ok) {
            const objResponse = await response.json();
            if (objResponse.iResponseType == 1) {
                const data = JSON.parse(objResponse.detalles);
                // Asumiendo que el SP nuevo retornará las alertas en una estructura sencilla, por ejemplo 'Table' o 'table5'
                // Adaptar si el SP retorna un formato diferente
                setAlertasPagos(data['Table2']?.[0] || data['table2']?.[0] || data['Table1']?.[0] || data['Table4']?.[0] || data['table1']?.[0] || data['table4']?.[0] || data['table5']?.[0] || {});
            }
        }
        setCargando(false);
    };

    return (
        <Row className="mb-3 g-3">
            {cargando ? (
                <>
                    <Col md={6}>
                        <Skeleton height={55} borderRadius="0.5rem" />
                    </Col>
                    <Col md={6}>
                        <Skeleton height={55} borderRadius="0.5rem" />
                    </Col>
                </>
            ) : (
                <>
                    <Col md={6}>
                        <div
                            className="p-3 d-flex align-items-center h-100"
                            style={{ backgroundColor: '#fff7ed', color: '#c2792c', borderRadius: '1rem' }}
                        >
                            <FontAwesomeIcon icon="flag" className="me-3 fs-3" style={{ color: '#c2792c' }} />
                            <span className="fs--1">
                                Los <b>totales</b> están basados en todos los pagos <b>ACTIVOS</b> registrados según los filtros seleccionados.
                            </span>
                        </div>
                    </Col>

                    <Col md={6}>
                        {showAlertas && (alertasPagos.numNoValidados > 0 || alertasPagos.numNoFacturados > 0 || alertasPagos.numNoActivos > 0) ? (
                            <div
                                className="p-3 d-flex align-items-center h-100"
                                style={{ backgroundColor: '#fdf2f2', border: '1px solid #f8d7da', color: '#e63757', borderRadius: '1rem' }}
                            >
                                <FontAwesomeIcon icon="flag" className="me-3 fs-3" style={{ color: '#dc3545' }} />
                                <div className="fs--1 d-flex flex-wrap gap-3">
                                    {alertasPagos.numNoValidados > 0 &&
                                        <span><b>{alertasPagos.numNoValidados}</b> pagos <b>NO validados.</b></span>
                                    }
                                    {alertasPagos.numNoFacturados > 0 &&
                                        <span><b>{alertasPagos.numNoFacturados}</b> pagos <b>NO FACTURADOS.</b></span>
                                    }
                                    {alertasPagos.numNoActivos > 0 &&
                                        <span><b>{alertasPagos.numNoActivos}</b> pagos <b>Cancelados.</b></span>
                                    }
                                </div>
                            </div>
                        ) : (
                            <div className="p-3 d-flex align-items-center h-100" style={{ backgroundColor: '#fdf2f2', border: '1px solid #f8d7da', color: '#00d27a', borderRadius: '1rem' }}>
                                <FontAwesomeIcon icon="check-circle" className="me-3 fs-3" style={{ color: '#00d27a' }} />
                                <span className="fs--1 fw-semi-bold">No hay pagos pendientes de revisión con los filtros actuales.</span>
                            </div>
                        )}
                    </Col>
                </>
            )}
        </Row>
    );
};

PagosAlertas.propTypes = {
    filters: PropTypes.object.isRequired,
    refreshTrigger: PropTypes.number
};

export default PagosAlertas;
